import React, { useState } from 'react';
import axios from 'axios';
import { Lock } from 'lucide-react';
import { useAdminAuth } from '../context/AdminAuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AdminLogin = () => {
  const { login } = useAdminAuth();
  const [pw, setPw] = useState('');
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      // Verify by hitting a protected endpoint
      await axios.get(`${API}/orders/summary`, { headers: { 'X-Admin-Password': pw } });
      login(pw);
    } catch (err) {
      const status = err?.response?.status;
      if (status === 401) {
        setErr('Incorrect admin password.');
      } else if (status === 404) {
        setErr('Backend endpoint not found (404). The server is likely running an old build — please redeploy.');
      } else if (status === 429) {
        setErr('Too many attempts. Wait a minute and try again.');
      } else if (status >= 500) {
        setErr(`Server error (${status}). Please try again in a moment.`);
      } else if (!err?.response) {
        setErr('Cannot reach the backend. Check your internet connection or backend URL.');
      } else {
        setErr(`Login failed (HTTP ${status}). ${err?.response?.data?.detail || ''}`);
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen w-full bg-[#F8F8F6] dark:bg-[#0F0F10] flex items-center justify-center px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-white dark:bg-[#141416] border border-neutral-200 dark:border-neutral-800 rounded-2xl p-8 shadow-sm">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-10 h-10 rounded-full bg-[#1e293b] text-white grid place-items-center"><Lock size={18} /></div>
          <div>
            <div className="font-serif text-[22px] leading-none text-neutral-900 dark:text-neutral-100">Admin Sign in</div>
            <div className="text-[12.5px] text-neutral-500 mt-1">Healsglobe Exports Order Dashboard</div>
          </div>
        </div>

        <label className="block text-[10.5px] tracking-[0.15em] text-neutral-500 uppercase mb-1.5">Admin password</label>
        <input
          type="password"
          data-testid="admin-password-input"
          value={pw}
          onChange={(e) => setPw(e.target.value)}
          placeholder="Enter admin password"
          className="w-full bg-white dark:bg-[#0f0f10] border border-neutral-200 dark:border-neutral-800 rounded-md px-3 py-3 text-[14px] outline-none focus:border-neutral-400 dark:focus:border-neutral-600"
          autoFocus
        />
        {err && <p data-testid="admin-login-error" className="text-red-600 text-[13px] mt-3">{err}</p>}

        <button
          type="submit"
          data-testid="admin-signin-btn"
          disabled={loading || !pw}
          className={`mt-5 w-full rounded-lg py-3 text-[14.5px] font-medium transition-colors ${(loading || !pw) ? 'bg-neutral-300 dark:bg-neutral-700 text-white cursor-not-allowed' : 'bg-[#1e293b] hover:bg-[#0f172a] text-white'}`}
        >
          {loading ? 'Verifying…' : 'Sign in'}
        </button>

        <p className="text-[11.5px] text-neutral-500 mt-4 text-center">
          Contact your developer if you’ve forgotten this password.
        </p>
      </form>
    </div>
  );
};

export default AdminLogin;
